"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodsBannerLazyRoot = void 0;
const react_1 = __importDefault(require("react"));
const PaymentMethodsBannerLazy_1 = require("./PaymentMethodsBannerLazy");
const PaymentMethodsBannerLazyRoot = (props) => {
    if (props.isSSR) {
        return null;
    }
    return react_1.default.createElement(PaymentMethodsBannerLazy_1.PaymentMethodsBannerLazy, Object.assign({}, props));
};
exports.PaymentMethodsBannerLazyRoot = PaymentMethodsBannerLazyRoot;
//# sourceMappingURL=root.js.map